<template>
  <div class="wrapper">
    <page-header :title="header.title" :add-button="header.addButton" />
    <filters />
    <inner-list
      :loading="loading"
      :results="results"
      :pagination="pagination"
    />
  </div>
</template>
<script>
import InnerList from './InnerList'
import Filters from './Filters'
import { Lecturer } from '@/api'
import PaginatedList from '@/components/layout/PaginatedList'

export default {
  extends: PaginatedList,
  components: {
    InnerList,
    Filters
  },
  data() {
    return {
      service: Lecturer
    }
  },
  computed: {
    header() {
      let title = `Lista lektorów`
      if (this.pagination.total) {
        title = `${title} <sup>(${this.pagination.total})</sup>`
      }
      return {
        addButton: {
          label: 'Dodaj lektora',
          route: {
            path: '/admin/dodaj-lektora/'
          }
        },
        title
      }
    }
  }
}
</script>
